<template>
  <div>
    <div class="page-title">訊息詳情 Message Detail</div>
    <div class="page-detail">
      <div style="white-space: pre-wrap;" v-if="detail.eventStatus" class="fs-title">
          {{ detail.eventStatus.title }}
        </div>
     
      <div
        style="margin-top: 20px;"
        v-html="information.paymentTemplateContent"
      ></div>
      <div id="your-container-element"></div>
      <copyrightCard></copyrightCard>
    </div>
    <loadingDialog :centerDialogVisible="loading" loadingText="交易進行中請家長耐心等侯，請勿刷新版面"></loadingDialog>
  </div>
</template>

<script>
import { getSetting } from "@/api/parent/setting";
import {
  getApplicationDetail,
  addApplicationPayRequests,
  addApplicationCompletePaidRequests,
} from "@/api/parent/application";
import { loadScript } from "@paypal/paypal-js";
import copyrightCard from "@/components/copyrightCard";
import loadingDialog from "@/components/loadingDialog";
export default {
  components: { copyrightCard,loadingDialog },
  props: {
    applicationId: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      loading: false,
      detail:{},
      information: {},
      payPalData: {},
      token: "",
    };
  },
  created() {
    this.addApplicationPayRequests();
    this.getSetting();
    this.getApplicationDetail()
  },
  methods: {
    getSetting() {
      getSetting().then((v) => {
        this.information = v.data;
      });
    },
    addApplicationCompletePaidRequests(orderId) {
      let from = {
        orderId: orderId,
      };
      addApplicationCompletePaidRequests(this.applicationId, from).then(
        () => {
          this.$router.push({ path:`/parent/application` });
        }
      ).finally(
        () => {
           this.loading = false;
        }
      );
    },
    addApplicationPayRequests() {
      addApplicationPayRequests(this.applicationId).then((v) => {
        this.initialize(v.data);
        this.payPalData = v.data;
        this.$forceUpdate();
      });
    },
    initialize(data) {
      let that = this;
      let from = {
        "client-id": data.clientId,
        currency: data.currencyCode,
      };
      loadScript(from)
        .then((paypal) => {
          paypal
            .Buttons({
              createOrder: function (datas, actions) {
                // Set up the transaction
                return actions.order.create({
                  application_context: {},
                  intent: "CAPTURE",
                  purchase_units: [
                    {
                      reference_id: data.referenceId,
                      amount: {
                        value: data.amount, // 订单金额
                      },
                    },
                  ],
                });
              },
              // 用户支付成功
              onApprove: function (data) {
                that.loading = true;
                that.addApplicationCompletePaidRequests(data.orderID);
              },
              // 错误处理
              onError: function (error) {
                that.$message.error("支付错误 ");
                console.error( "支付错误 "  +  error);
              },
            })
            .render("#your-container-element")
            .catch((error) => {
              console.log("failed to render the PayPal Buttons", error);
            });
        })
        .catch((err) => {
          console.log("failed to load the PayPal JS SDK script", err);
        });
    },
    getApplicationDetail(){
      getApplicationDetail(this.applicationId).then((v)=>{
         this.detail = v.data
      })
    }
  },
};
</script>

<style lang="scss" scoped>
.page-detail {
  background-color: #fff;
  padding: 0 40px;
  padding-top: 60px;
}
.list {
  margin-bottom: 40px;
}
</style>